<template >
  <div
    class="form-group formways-component formways-datetime"
    :class="ctx.customClass"
    v-if="!ctx.hidden"
  >
    <label :for="ctx.key">
      {{ ctx.label }}
      <span v-if="ctx.validate.required" class="text-danger">*</span>
      <i
        v-if="ctx.tooltip"
        class="fa fa-question-circle"
        aria-hidden="true"
        data-toggle="tooltip"
        data-placement="right"
        :title="ctx.tooltip"
      ></i>
    </label>

    <div class="input-group">
      <input
        type="text"
        class="form-control"
        :id="ctx.key"
        :placeholder="ctx.placeholder"
        :required="ctx.validate.required"
        :disabled="ctx.disabled"
        v-model="value"
      />
      <div class="input-group-append" @click="showCalendarWidget">
        <div class="input-group-text" id="btnGroupAddon">
          <i style="" class="fa fa-calendar" ref="icon"></i>
        </div>
      </div>
    </div>

    <small :id="ctx.key + 'Help'" class="form-text text-muted">
      {{ ctx.description }}
    </small>
  </div>
</template>

<script>
import flatpickr from 'flatpickr';
import FieldMixin from '../../mixins/FieldMixin';
import { convertFormatToFlatpickr } from '../../utils';
import '../../../node_modules/flatpickr/dist/themes/light.css';
import defaultSchema from './defaultSchema';

export default {
  name: 'datetime',
  mixins: [FieldMixin],
  beforeCreate() {
    // Default schema
    this.defaultSchema = defaultSchema;
  },
  // created() {

  // },
  async mounted() {
    if (this.ctx.hidden) return;
    const self = this;
    const element = this.$el.querySelector(`#${this.ctx.key}`);
    // Reference : https://flatpickr.js.org/formatting/
    this.dateTimePicker = flatpickr(element, {
      dateFormat: self.getBackEndDateFormat(),
      allowInput: self.ctx.widget.allowInput,
      altInput: true,
      altFormat: convertFormatToFlatpickr(self.ctx.widget.format),
      enableTime: self.ctx.widget.enableTime,
      noCalendar: self.ctx.widget.noCalendar,
      hourIncrement: self.ctx.widget.hourIncrement,
      minuteIncrement: self.ctx.widget.minuteIncrement,
      time_24hr: self.ctx.widget.time_24hr,
      minDate: self.ctx.widget.minDate,
      maxDate: self.ctx.widget.maxDate,
      mode: self.ctx.widget.mode
    });
    await this.initFieldValue();
  },
  methods: {
    showCalendarWidget() {
      this.dateTimePicker.open();
    },
    getBackEndDateFormat() {
      if (!this.ctx.enableDate && this.ctx.enableTime) {
        return 'H:i:S';
      }
      if (this.ctx.enableDate && !this.ctx.enableTime) {
        return 'Y-m-d';
      }
      return 'Y-m-d H:i:S';
    },
    async reset() {
      // this.value = '';
      this.dateTimePicker.clear();
      await this.initFieldValue();
    }
  },
  watch: {
    value(value) {
      setTimeout(() => {
        this.dateTimePicker.setDate(value, true, 'Y-m-d H:i:S');
      }, 0);
    }
  }
};
</script>
